export const getRedirectUri = () => {
  let domain = window.location.host;

  if (domain.indexOf("localhost") === -1) {
    return "https://" + domain + "/";
  }

  return "http://" + domain;
};



// WEBPACK FOOTER //
// ./src/utils/FacebookUtils.js